/**
 * Turn-clock cues in `public/audio/`, ogg and m4a.
 * The last five seconds play `timer-tick-5` … `timer-tick-1`, one file each.
 * Tick 5 is about 0.6s. Ticks 4 through 1 are about 0.98s. Zero plays
 * `timer-zero`, about 1.45s.
 * A new cue stops the one that is still playing, so they never overlap.
 */

export const TIMER_ZERO_FILE = 'timer-zero';

export const TIMER_TICK_FILES = [
  'timer-tick-5',
  'timer-tick-4',
  'timer-tick-3',
  'timer-tick-2',
  'timer-tick-1',
] as const;

export const TIMER_CUE_FILES = [...TIMER_TICK_FILES, TIMER_ZERO_FILE] as const;

/** The file for a displayed warning second. Anything outside 1–5 is not a tick. */
export function timerTickFile(secondsLeft: number): string | null {
  const second = Math.round(secondsLeft);
  if (second < 1 || second > 5) return null;
  return `timer-tick-${second}`;
}

/**
 * One clock cue at a time. `begin` retires whatever token is in flight,
 * so a tick that finishes loading after the next second started does not play.
 */
export class TimerCueGate {
  private token = 0;

  begin(): number {
    this.token += 1;
    return this.token;
  }

  owns(token: number): boolean {
    return token === this.token;
  }
}
